import {SizesSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';

export const getCurrentSelectedSizeFromSizesSection = (
  sizesSection: SizesSection,
  selectedSize: SelectedSize,
) => {
  const sizeSelectionType = sizesSection.sizeSelection.type;

  const sizes: SelectedSize[] = (() => {
    switch (sizeSelectionType?.$case) {
      case 'groupedSizes': {
        return sizeSelectionType.groupedSizes.groups.reduce(
          (partial, group) => {
            if (group.content?.$case === 'sizes') {
              partial.push(...group.content.sizes.sizes);
            } else if (group.content?.$case === 'sizeRuns') {
              partial.push(
                ...group.content.sizeRuns.sizeRuns.reduce(
                  (partial, sizeRun) => [...partial, ...sizeRun.sizes],
                  [] as SelectedSize[],
                ),
              );
            }
            return partial;
          },
          [] as SelectedSize[],
        );
      }
      case 'inlineSelection':
        return sizeSelectionType.inlineSelection.sizes;
      case 'oneSize':
        return [sizeSelectionType.oneSize.size];
      case 'sizeRuns':
        return sizeSelectionType.sizeRuns.sizeRuns.reduce(
          (partial, sizeRun) => [...partial, ...sizeRun.sizes],
          [] as SelectedSize[],
        );
      case 'sizes':
        return sizeSelectionType.sizes.sizes;
      default:
        return [];
    }
  })();

  const updatedSize =
    sizes.find(
      size =>
        size?.sizeId === selectedSize?.sizeId &&
        size?.label === selectedSize?.label,
    ) ?? sizes.find(size => size?.sizeId === selectedSize?.sizeId);

  return updatedSize;
};
